var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemCloseSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M9.529 5.529 8 7.057 6.471 5.53a.666.666 0 1 0-.942.942L7.057 8 5.53 9.529a.666.666 0 1 0 .942.942l1.53-1.528 1.528 1.528a.665.665 0 0 0 .942 0 .666.666 0 0 0 0-.942l-1.528-1.53 1.528-1.528a.666.666 0 1 0-.942-.942",
  clipRule: "evenodd"
})));
export default SvgGemCloseSmall;